import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css"
// import InternationalBrands from "../../../images/InternationalBrands.svg"
// import Image from "next/image"
// import Link from "next/link"
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  minWidth:350,
  bgcolor: 'background.paper',
  border: '0px solid #000',
  borderRadius: '16px',
  boxShadow: 24,
  p: 4,
  overflow:'scroll',
  height:'100%',
};

export default function BrandsModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button style={{ padding:"5px 20px" }} onClick={handleOpen}>بیشتر بخوانید</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <div dir="rtl">
              <p>
              تأمین کالای سالم و مطابق با انتظارات مشتریان هدف و رسالت نهایی دیجی‌کالاست. ضمانت اصل بودن کالا یکی از ویژگی‌های اصلی و مهم خرید از دیجی‌کالاست و منظور از آن گارانتی اصالت و سلامت فیزیکی است. این گارانتی دیجی‌کالا را متعهد می‌کند که کالا را سالم به دست مشتری برساند. با این حال متاسفانه ممکن است کالاها در مراحل مختلف تأمین، تحویل به انبار، پردازش و ارسال از نظر فیزیکی دچار مشکل شوند. تأثیر این مشکلات، بخش‌های مختلف کسب‌وکار دیجی‌کالا را تحت تأثیر قرار می‌دهد.
              </p>

              <p>
              ما برای کاهش آمار این نوع نارضایتی‌ها پروژه کاهش آسیب دیدگی کالاها را با رویکرد پیشگیرانه و با هدف کاهش خطاهایی که در فرایندهای عملیات و لجستیک رخ می‌دهد در قالب چند رویه تعریف کرده‌ایم:
              </p>
              <h5 className={cx(styles.innerHeadings , "mb-3" )}>بهبود فرایند کنترل کیفی کالاهای دریافتی</h5>
              <p>در این رویه کالاهایی که ممکن است از نظر سلامت محوری حساسیت بالایی داشته باشند (مانند لوازم آرایشی و بهداشتی) یا احتمال تقلبی یا قاچاق بودن بیشتری داشته باشند (مانند موبایل و کالاهای الکترونیک) و مرجوعی آنها با چالش روبروست (طلا و جواهرات) به صورت ویژه بازبینی می‌شوند.</p>
              
              <h5 className={cx(styles.innerHeadings, "mb-3"  )}>آموزش به فروشندگان</h5>
              <p>در این اقدام به فروشندگان آموزش‌های لازم مطابق با نیازمندهای فرایند پردازش و ارسال سفارش‌ها داده می‌شود.</p>

              <h5 className={cx(styles.innerHeadings, "mb-3" )}>دسته بندی هدفمند کالاها</h5>
              <p>با این کار از قرارگیری کالاهای نامتعارف در کنار یکدیگر جلوگیری می‌شود و میزان ضایعات و آسیب دیدگی پایین می‌آید.</p>

              <div className={cx(styles.purpleContainer)}>
                  <div className="d-flex text-center py-3">
                    <h6>کالاهای آسیب دیده پس از بررسی در صورتی که امحا نشوند و قابلیت برگشت به چرخه مصرف داشته باشند به صورت داخلی یا اهدا به مؤسسات خیریه دوباره قابل استفاده هستند.</h6>
                  </div>
              </div>
            </div>
          
        </Box>
      </Modal>
    </div>
  );
}